import { FixedComponentsRateChartRequest, FixedComponentsRateChartResponseModel } from "@gtpl/shared-models/masters";
import { connection } from "..";
import axios from "axios";

export class FixedComponentsRateChartService {
    activatedeActivate(data: FixedComponentsRateChartRequest) {
        throw new Error('Method not implemented.');
      }
      URL = connection.DEPLOY_URL + '/fixed-components-rate-chart';
    
      async createFixedComponentsRateChart(req:FixedComponentsRateChartRequest): Promise<FixedComponentsRateChartResponseModel> {
        return await axios.post(this.URL + '/createFixedComponentsRateChart', req)
          .then(res => {
            return res.data
          })
      }
      async getAllFixedComponentsRateChartInfo(): Promise<FixedComponentsRateChartResponseModel> {
        return await axios.post(this.URL + '/getAllFixedComponentsRateChartInfo')
          .then(res => {
            return res.data
          })
      }
      async updateFixedComponentsRateChart(req:FixedComponentsRateChartRequest): Promise<FixedComponentsRateChartResponseModel> {
        return await axios.post(this.URL + '/updateFixedComponentsRateChart',req)
            .then(res => {
                return res.data
            }) 
    }
}